import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import ServicesAI from "./pages/ServicesAI";
import ServicesWeb from "./pages/ServicesWeb";
import ServicesSocial from "./pages/ServicesSocial";
import ServicesSeo from "./pages/ServicesSeo";
import ServicesTraining from "./pages/ServicesTraining";
import ServicesDpo from "./pages/ServicesDpo";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/ai" element={<ServicesAI />} />
            <Route path="/services/web" element={<ServicesWeb />} />
            <Route path="/services/social" element={<ServicesSocial />} />
            <Route path="/services/seo" element={<ServicesSeo />} />
            <Route path="/services/training" element={<ServicesTraining />} />
            <Route path="/services/dpo" element={<ServicesDpo />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
